import { Response } from "../api.interface";
import newColorAxiosInstance from "../new-color-axiosInstance";
import {
  AnonymousRes,
  DeleteCommentReqParams,
  DeleteCommentRes,
  DeleteReplyParams,
  DeleteReplyRes,
  HandleHelpfulRes,
  HelpfulReqParams,
  PublishReplyReq,
  PublishRes,
  TranslateParams,
  TranslateRes,
  UserReviewedDetailResponse,
} from "./review.interface";
const colorAxiosInstance = newColorAxiosInstance;
// api doc: https://joyspace.jd.com/pages/OKN92AcEPEEiX1TYiRMc

// rbi.b2c.v1_1.comment.getUserCommentedList 用户已评价详情
export const fetchUserReviewDetail = async ({
  commentId,
  parentReplyId,
  skuId,
}: {
  commentId: string;
  parentReplyId: string | number;
  skuId: string;
}): Promise<UserReviewedDetailResponse | null> => {
  const res = await colorAxiosInstance.get<Response<UserReviewedDetailResponse>>(
    `content_review_get`,
    {
      params: {
        commentId,
        parentReplyId,
        skuId,
        pageSize: 30,
      },
    },
  );
  if (res?.data?.success) {
    // @ts-ignore
    return res?.data;
  }
    // @ts-ignore
  return res?.data;
};

// rbi.b2c.v1_1.comment.publishReplyComment 发表回复

export const publishReplyComment = async (params: PublishReplyReq): Promise<PublishRes | null> => {
  const res = await colorAxiosInstance.get<Response<PublishRes>>(`content_review_reply`, {
    params,
  });
  console.log("res 999", res);
  if (res?.data?.success) {
    // @ts-ignore
    return res?.data;
  }
    // @ts-ignore
  return res?.data;
};

// 点赞/取消点赞接口
export const handleHelpfulOperation = async ({
  commentId,
  operation,
}: HelpfulReqParams): Promise<HandleHelpfulRes | null> => {
  const res = await colorAxiosInstance.post<Response<HandleHelpfulRes>>(
    "content_review_like",
    undefined,
    {
      params: {
        commentId,
        operation,
      },
    },
  );
  if (res?.data?.success) {
    // @ts-ignore
    return res?.data;
  }
    // @ts-ignore
  return res?.data;
};

// 删除商品评论 rbi.b2c.v1_1.comment.deleteComment
export const handleDeleteComment = async ({
  commentId,
  skuId,
}: DeleteCommentReqParams): Promise<DeleteCommentRes | null> => {
  const res = await colorAxiosInstance.post<Response<DeleteCommentRes>>(
    "content_review_delete",
    undefined,
    {
      params: {
        commentId,
        skuId,
      },
    },
  );
  if (res?.data?.success) {
    // @ts-ignore
    return res?.data;
  }
    // @ts-ignore
  return res?.data;
};

// 匿名 rbi.b2c.v1_1.comment.setAnonymousFlag
export const handleAnonymous = async ({
  commentId,
  skuId,
  anonymous, //  1-匿名 0-非匿名
}: DeleteCommentReqParams & { anonymous: number }): Promise<AnonymousRes | null> => {
  const res = await colorAxiosInstance.post<Response<DeleteCommentRes>>(
    "content_review_setAnonymous",
    undefined,
    {
      params: {
        commentId,
        skuId,
        anonymous,
      },
    },
  );
  if (res?.data?.success) {
    // @ts-ignore
    return res?.data;
  }
    // @ts-ignore
  return res?.data;
};
// 删除商品评论 rbi.b2c.v1_1.comment.deleteComment
export const handleDeleteReply = async ({
  skuId,
  replyId,
}: DeleteReplyParams): Promise<DeleteReplyRes | null> => {
  const res = await colorAxiosInstance.post<Response<DeleteReplyRes>>(
    "content_review_deleteReply",
    undefined,
    {
      params: {
        replyId,
        skuId,
      },
    },
  );
  if (res?.data?.success) {
    // @ts-ignore
    return res?.data;
  }
    // @ts-ignore
  return res?.data;
};

// 获取举报原因
export const getReportReason = async (): Promise<any | null> => {
  const res = await colorAxiosInstance.get<Response<any>>(
    "content_review_getReportReasons",
    undefined,
  // @ts-ignore
    {},
  );
  // @ts-ignore
  if (res?.data?.success) {
  // @ts-ignore
    return res?.data?.data;
  }
  return null;
};

// 举报评论
export const reportComment = async (params: any) => {
  const res = await colorAxiosInstance.post<Response<any>>("content_review_report", undefined, {
    params,
  });
  if (res?.data?.success) {
    return res?.data?.data;
  }
  return null;
};

// 翻译
export const getTranslated = async ({
  text,
  targetLang
}:TranslateParams):Promise<TranslateRes|null> => {
  const res = await colorAxiosInstance.post<Response<TranslateRes>>(
    "content_review_translate",
    undefined,
    {
      params: {
        text, 
        targetLang
      },
    }
  );
  if (res?.data?.success) {
     // @ts-ignore
     return res?.data;
  }
   
   return null;
}
